enum LikeSize {
  SMALL = 'small',
  LARGE = 'large',
}

export default LikeSize;
